
(function() {
    let textLinks = document.querySelectorAll('a[href*="#"]');
    textLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {

            let href = link.getAttribute('href');
            const sectionToScroll = document.querySelector(href);

            if(!sectionToScroll) return;

            e.preventDefault();

            const header = document.querySelector('sticky-header');
            const headerHeight = header ? header.offsetHeight : 0;
            const offset = 20;
            const targetPosition = sectionToScroll.getBoundingClientRect().top + window.pageYOffset - headerHeight - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        });
    });
})();